<script lang="ts" setup>
    import FabricCanvasContainer from '@/components/FabricCanvasContainer.vue';
    import FabricProductCanvasContainer from '@/components/FabricProductCanvasContainer.vue';
    import ContextMenu from '@/components/ContextMenu.vue';
    import MobileBar from '@/components/MobileBar.vue';
    import { useProductHas3d } from '@/composables/useProductHas3d';
    import { useConfigStore } from '@/store/config.store';
    import { EProductFormat } from '@/typescript/enums/EProductFormat';
    import { storeToRefs } from 'pinia';
    import type { TSides } from '@/typescript/interfaces/TSide';

    defineEmits<{
        toggleRectoVerso: [view: TSides];
    }>();
    const { currentSide, productFormat } = storeToRefs(useConfigStore());
    const { productHas3DModel } = useProductHas3d();
</script>
<template>
    <div class="h-dvh w-full">
        <MobileBar class="z-10" />
        <FabricProductCanvasContainer
            v-if="!productHas3DModel && currentSide === 'recto'"
            :format="'recto'"
        />
        <FabricProductCanvasContainer
            v-if="!productHas3DModel && productFormat === EProductFormat.RECTO_VERSO"
            v-show="currentSide === 'verso'"
            :format="'verso'"
        />
        <FabricCanvasContainer v-if="productHas3DModel" />
        <ContextMenu />
    </div>
</template>
